import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGofundmeComponent } from './simple-icons-gofundme.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGofundmeComponent ],
    exports:      [ SimpleIconsGofundmeComponent ],
    bootstrap:    []
})
export class SimpleIconsGofundmeModule {}
